import { render } from "./CreateEditTeacher.vue?vue&type=template&id=b4efa096"
import script from "./CreateEditTeacher.vue?vue&type=script&lang=js"
export * from "./CreateEditTeacher.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__